import { produce } from "immer";
import { PageAction, UPDATE_PAGE, SET_LOCALE } from "./page.actions";
import UmbracoPageRootState from "app/umbraco/models/page-redux-state.interface";

const initialState: UmbracoPageRootState = {
    content: undefined,
    statusCode: 0,
    languageUrl: "/",
    languageId: "da",
    redirectUrl: undefined
};

export default (pageState = initialState, action: PageAction): UmbracoPageRootState => produce(pageState, draft => {
    switch (action.type) {
        case UPDATE_PAGE: {
            draft.content = action.content;
            draft.statusCode = action.statusCode;
            draft.redirectUrl = action.redirectUrl;
            break;
        }
        case SET_LOCALE: {
            draft.languageUrl = action.languageUrl;
            draft.languageId = action.languageId;
            break;
        }
    }
});
